import { mediaEntity } from '@/src/entities/media'

export function destroy() {
  mediaEntity.model.mediaLocalStreamRemove()
}
